module.exports = "#brochure-list .ibox-content{\n        max-height: 295px;\n        overflow-y: auto;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/brochures/brochures.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/brochures/brochures.component.css
// module chunks = main